import api from "../../../config/gatewayConfig";
import { httpClient, silentPollingConfig } from "../../httpClient";

function mapVendorPaymentMethodsResponse(payload) {
  if (payload == null || typeof payload !== "object") return [];
  const metodi = Array.isArray(payload.metodi) ? payload.metodi : [];
  const associazioni = Array.isArray(payload.associazioni) ? payload.associazioni : [];
  const associatedIds = new Set(
    associazioni.map((a) => a.metodoPagamentoId).filter((id) => id != null)
  );
  return metodi.map((m) => ({
    id: m.id,
    descrizione: m.descrizione ?? "",
    urlLogo: m.urlLogo ?? "",
    associato: associatedIds.has(m.id),
  }));
}

export const apiPagamentiProvider = {
  metodiPagamenti: async () => {
    const response = await httpClient.post(`${api.vendorPaymentMethodsGet}`, {}, {
      headers: { "Content-Type": "application/json" },
      ...silentPollingConfig,
    });
    return mapVendorPaymentMethodsResponse(response.data);
  },

  associaMetodiPagamentoUtente: async (_idVendor, associazioni) => {
    const response = await httpClient.post(
      `${api.vendorPaymentMethodsModifica}`,
      { associazioni },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  },
};
